export async function loadImage(src: string): Promise<string> {
  const isHeicByExtension =
    src.toLowerCase().endsWith(".heic") || src.toLowerCase().endsWith(".heif");

  let isHeic = isHeicByExtension;

  if (src.startsWith("blob:")) {
    try {
      const res = await fetch(src);
      const blob = await res.blob();
      const mimeType = blob.type.toLowerCase();

      const isHeicByMime =
        mimeType.includes("heic") || mimeType.includes("heif");

      const isHeicBySignature = await checkHeicSignature(blob);

      isHeic = isHeicByMime || isHeicBySignature;

      if (isHeic) {
        const converted = await convertHeicToPng(blob);
        return converted;
      }
    } catch (e) {
      console.error("Failed to check blob type:", e);
      return src;
    }
  } else if (isHeic) {
    try {
      const res = await fetch(src);
      const blob = await res.blob();
      const converted = await convertHeicToPng(blob);
      return converted;
    } catch (e) {
      console.error("HEIC conversion failed:", e);
      throw e;
    }
  }

  return src;
}

async function checkHeicSignature(blob: Blob): Promise<boolean> {
  try {
    const arrayBuffer = await blob.slice(0, 12).arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);

    if (uint8Array.length >= 8) {
      const ftyp = String.fromCharCode(
        uint8Array[4],
        uint8Array[5],
        uint8Array[6],
        uint8Array[7]
      );
      if (ftyp === "ftyp") {
        const brand = String.fromCharCode(
          uint8Array[8],
          uint8Array[9],
          uint8Array[10],
          uint8Array[11]
        );
        return brand === "heic" || brand === "heix" || brand === "mif1";
      }
    }
    return false;
  } catch (e) {
    console.error("Failed to check HEIC signature:", e);
    return false;
  }
}

async function convertHeicToPng(file: Blob): Promise<string> {
  const convert = (await import("heic-convert/browser")).default;

  const arrayBuffer = await file.arrayBuffer();
  const outputBuffer = await convert({
    buffer: new Uint8Array(arrayBuffer) as unknown as ArrayBuffer,
    format: "PNG",
  });

  const convertedBlob = new Blob([outputBuffer], { type: "image/png" });
  return URL.createObjectURL(convertedBlob);
}
